const AllExpertsPage = () => import('./index.vue')
const ExpertPortfolio = () => import('./_components/portfolio.vue')
import { EngageExpertGuard, CheckSonkoGuard } from '@/common/guard'

export default [
    {
        path: '/all/experts',
        beforeEnter: CheckSonkoGuard,
        component: AllExpertsPage,
        name: 'AllExpertsPage'
    },
    {
        path: '/expert/portfolio/:id',
        beforeEnter: EngageExpertGuard,
        component: ExpertPortfolio,
        name: 'ExpertPortfolioPage'
    }
]